import React, { useEffect }  from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate  } from 'react-router-dom';
import { Formik } from 'formik';
import logo from '../../assets/img/fc_dallas_logo.png';
import login_bg from '../../assets/img/login_bg.png';
import { LoginValidate } from '../../assets/validation/validation';
import { authAction } from './../../redux/actions/authAction';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Grid from '@mui/material/Grid';
import { Loader } from '../../errorPages/Loader';
import CircularProgress from '@mui/material/CircularProgress';

const LoginForm = (props) => {
    let navigate = useNavigate();
    const { loggedIn, isLoading } = useSelector(state => state.authentication); 
    const dispatch = useDispatch();


    useEffect(() => { 
        if(loggedIn){
            navigate('/shop'); 
        }
    }, [loggedIn, navigate]);



    return (
        <div>
        { isLoading === true ? <Loader/> : '' }
        <Formik
            initialValues={{
                email: '',
                password : '',
                remember_me: ''
            }}
            enableReinitialize
            validationSchema={LoginValidate}
            onSubmit={(values, {setErrors, setSubmitting}) => {
                dispatch(authAction.login(values, setErrors, setSubmitting)); 
            }}>
            {({ errors, touched, values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                <form onSubmit={handleSubmit}> 
                    <div className="form_wrapper">
                        <Box sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100vh',
                        }}>
                            <div>
                            <Box className='login__wrap'>
                                <Grid container alignItems={"center"}>
                                    <Grid item xs={6} sx={{p:6  }}>
                                        <img src={logo} alt="Logo" />
                                        <Typography variant="h3" gutterBottom component=""  mb={2}>
                                            Login
                                        </Typography>
                                        <Paper elevation={0} sx={{background:"none"}}>
                                            <TextField
                                                error={errors.email && touched.email}
                                                label="Email Address"
                                                fullWidth 
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                helperText={(errors.email && touched.email) && errors.email}
                                                margin="normal"
                                                variant="standard"
                                                required={false}
                                                InputLabelProps={{ required: true }} 
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                            aria-label="toggle password visibility"
                                                            disabled
                                                            //onClick={handleClickShowPassword}
                                                            edge="end"
                                                            >
                                                            {<i className='icon-email'></i>}
                                                            </IconButton>
                                                        </InputAdornment>
                                                }}

                                            />
                                            <TextField
                                                id="filled-password-input"
                                                fullWidth
                                                variant="standard"
                                                label="Password"
                                                name="password"
                                                type={'password'}
                                                autoComplete="current-password"
                                                margin="normal"
                                                error={errors.password && touched.password}
                                                value={values.password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                helperText={(errors.password && touched.password) && errors.password}
                                                required={false}
                                                InputLabelProps={{ required: true }} 
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                            aria-label="toggle password visibility"
                                                            disabled
                                                            //onClick={handleClickShowPassword}
                                                            edge="end"
                                                            >
                                                            {<i className='icon-password'></i>}
                                                            </IconButton>
                                                        </InputAdornment>
                                                }}
                                            />
                                            <Button 
                                                type="submit"
                                                className='submit_btn' 
                                                variant="contained" 
                                                sx={{mt:5, mb:2}}
                                                size="large"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? <CircularProgress size={20}/> :  "Login"}
                                            </Button>
                                        </Paper>
                                        <Typography variant="body1" mt={2} align="center">
                                        Forgot Your Password? <Link to="/forget-password">Click Here</Link>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <img src={login_bg} alt="Logo" />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Typography className='copyright_p' variant="body1" mt={2} align="center">
                                ©{props.year}
                            </Typography>
                            </div>
                        </Box>
                    </div>
                </form>
            )}
        </Formik>  
        </div>
    );
};
  export default LoginForm; 